import styled from 'styled-components';

export const InProgressContainer = styled.div``;
export const InProgressGrid = styled.div`
  display: grid;
  margin-top: 16px;
  grid-template-columns: ${props => `repeat(${props.columns || 4}, auto)`};
`;
